export const DATA_TABLE_ALIAS = 'do_data'
export const GEOM_TABLE_ALIAS = 'do_geom'

export const DATA_LIMIT = 50
